import React, { useState } from "react";
import { TabHeading } from "../../Global/TabHeading";
import PlanList from "./PlanList";
import CorporateOffers from "./CorporateOffers";

/**
 * Plans and the corporate offers sold against them share a screen because they share a
 * permission - corporate-offer/ is gated by manage_subscription_plans, the same as the plans
 * themselves - so a sidebar entry of its own would need a menu permission that is not seeded.
 */
const SubscriptionPlans = () => {
  const tabs = [
    { name: "Plans", id: 1 },
    { name: "Corporate Offers", id: 2 },
  ];
  const [activeId, setActiveId] = useState(1);

  return (
    <div className={`pro-w-100`}>
      <TabHeading
        data={tabs}
        uniqueId={"id"}
        activeId={activeId}
        handleClick={(item) => setActiveId(item?.id)}
      />
      {activeId === 1 ? <PlanList /> : <CorporateOffers />}
    </div>
  );
};

export default SubscriptionPlans;
